/*  React  */
import React, { createContext, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DeviceTableContext = createContext({});

export const DeviceTableContextProvider = ({ children }) => {
    const { t } = useTranslation();
    const [deletingId, setDeletingId] = useState(null);

    const providerValues = useMemo(
        () => ({
            deletingId,
            setDeletingId,
            t
        }),
        [deletingId, t]
    );

    return (
        <DeviceTableContext.Provider value={providerValues}>
            {children}
        </DeviceTableContext.Provider>
    );
};

export const useDeviceTableContext = () => {
    const context = useContext(DeviceTableContext);

    if (context === undefined) {
        throw new Error(
            '`useDeviceTableContext` must be used within `DeviceTableContextProvider`'
        );
    }

    return context;
};
